import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';
export const Heading = styled(Typography)(({ theme }) => (Object.assign({ padding: theme.spacing(4, 0) }, theme.typography.button)));
export const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(4),
    paddingBottom: theme.spacing(6),
}));
export const Icon = styled('a')(() => ({
    height: 30,
}));
//# sourceMappingURL=styles.js.map